import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { stopEntityDeleting } from '../../../entityManagement/actions';
import { isDeleting } from '../../../entityManagement/selectors';
import EntityDeleteDialog from '../../../entityManagement/components/EntityDeleteDialog';
import { getSelectedCategoryName } from '../../selectors/categories';
import { deleteResourceCategory } from '../../actions/categories';

interface StateProps {
    entityName: string;
    opened: boolean;
}

interface DispatchProps {
    onCancel: () => void;
    onConfirmation: () => void;
}

interface OwnProps {
    scope: string;
}

export default connect<StateProps, DispatchProps, OwnProps, ApplicationState>(
    createStructuredSelector({
        entityName: getSelectedCategoryName,
        opened: isDeleting,
    }),
    (dispatch: CommanderThunkDispatch, { scope }) => ({
        onCancel: () => dispatch(stopEntityDeleting(scope)),
        onConfirmation: () => dispatch(deleteResourceCategory(scope)),
    })
)(EntityDeleteDialog);
